import React, { useState, useEffect } from 'react';
import Page from 'src/components/Page';
import {
  Alert,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  Modal,
  Pagination,
  PaginationItem,
  Paper,
  Radio,
  RadioGroup,
  Snackbar,
  Stack,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import {
  LoadingButton,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineSeparator,
  Timeline
} from '@mui/lab';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import Iconify from 'src/components/Iconify';
import { useLocation, useNavigate } from 'react-router-dom';
import { Table } from '@material-ui/core';
import { api } from 'src/Api';
import CloseIcon from '@mui/icons-material/Close';

import NotesIcon from '@mui/icons-material/Notes';
// import moment from 'moment';
import moment from 'moment-timezone';
import MapComponent from 'src/components/MapComponent';

export default function Tracking() {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  const userData = JSON.parse(user);
  const { data } = location.state || {};

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <Page title={`Tracking | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center">
            <IconButton
              style={{
                marginRight: 12,
                height: 40,
                width: 70,
                borderRadius: 5,
                backgroundColor: 'rgba(249, 0, 1,0.1)'
              }}
              onClick={() => navigate(-1)}
            >
              <Iconify icon="ion:return-up-back" style={{ fontSize: 25, color: '#f90001' }} />
            </IconButton>

            <Typography variant="h4" sx={{ color: '#f90001' }}>
              Map
            </Typography>
          </Stack>
        </Stack>
        <Grid item xs={12} sm={11.9} lg={12}>
          <Box sx={{ height: '80vh', mt: 2 }}>
            <MapComponent data={data} followDriver={true} />
          </Box>
        </Grid>
        <Snackbar open={snackbarOpen} autoHideDuration={4000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Page>
  );
}
